import userQuery from './userQuery';
import appCategory from './appCategory';
import companyQuery from './companyQuery';
import companyQueryNoPage from './companyQueryNoPage';
import appInstanceDisable from './appInstanceDisable';
import appInstanceActivate from './appInstanceActivate';
import appMultiActivare from './appMultiActivare';
import permissionOverride from './permissionOverride';
import permissionQuery from './permissionQuery';
import companyUserQuery from './companyUserQuery';
import queryCategory from './queryCategory';
import companyUserQueryNoPage from './companyUserQueryNoPage';
import batchPermissionQuery from './batchPermissionQuery';
import batchPermissionOverride from './batchPermissionOverride';
export default {
    queryCategory,
    userQuery,
    appCategory,
    companyQuery,
    appInstanceDisable,
    appInstanceActivate,
    appMultiActivare,
    permissionOverride,
    permissionQuery,
    companyUserQuery,
    companyUserQueryNoPage,
    batchPermissionQuery,
    batchPermissionOverride,
    companyQueryNoPage
};


// WEBPACK FOOTER //
// ./src/api/appInstance/index.ts